export function selectSheetRunPages(entries) {
    const openEntries = entries.filter((entry)=>entry.isOpen);
    return {
        openEntries,
        visibleEntry: openEntries[openEntries.length - 1],
        // WHY: the drawer keeps sliding out after its last page closes, so it must keep rendering that page or it collapses to an empty chrome strip mid-animation.
        renderedEntries: openEntries.length > 0 ? openEntries : entries.slice(-1)
    };
}
export function selectSheetChrome(entries, visibleEntry) {
    var _ref, _ref1;
    var _this, _entries_;
    const currentPage = (_this = visibleEntry !== null && visibleEntry !== void 0 ? visibleEntry : entries[entries.length - 1]) === null || _this === void 0 ? void 0 : _this.sheetPage;
    // WHY: a page that joins an open run inherits the drawer's shape from the page that opened it.
    const runOpenerPage = (_entries_ = entries[0]) === null || _entries_ === void 0 ? void 0 : _entries_.sheetPage;
    return {
        paddingBottom: currentPage === null || currentPage === void 0 ? void 0 : currentPage.paddingBottom,
        height: (_ref = currentPage === null || currentPage === void 0 ? void 0 : currentPage.height) !== null && _ref !== void 0 ? _ref : runOpenerPage === null || runOpenerPage === void 0 ? void 0 : runOpenerPage.height,
        variant: (_ref1 = currentPage === null || currentPage === void 0 ? void 0 : currentPage.variant) !== null && _ref1 !== void 0 ? _ref1 : runOpenerPage === null || runOpenerPage === void 0 ? void 0 : runOpenerPage.variant
    };
}
